import styled from 'styled-components'
import media from '../../utils/media'

export default styled.h1`
  font-family: grad, serif;
  font-style: normal;
  font-weight: bold;
  color: ${props =>
    // @ts-expect-error
    props.light ? '#e2e9fb' : '#161466'
  };
  text-align: ${props =>
    // @ts-expect-error
    props.center ? 'center' : 'inherit'
  }
  ${media.only.xs`
    font-size: 32px;
    line-height: 40px;
    letter-spacing: 0.5px;
  `}
  ${media.only.sm`
    font-size: 40px;
    line-height: 48px;
    letter-spacing: 0.5px;
  `}
  ${media.only.md`
    font-size: 48px;
    line-height: 56px;
    letter-spacing: 0.5px;
  `}
  ${media.only.lg`
    font-size: 64px;
    letter-spacing: 0.5px;
  `}
  ${media.only.xl`
    font-size: 72px;
    line-height: 80px;
    letter-spacing: 0.5px;
  `}
`
